import React, { useRef, useEffect, useState, useLayoutEffect } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from 'moment';
import { Row, Col, Statistic } from 'antd';

am4core.useTheme(am4themes_animated);

function DeviceRefuelDrainBarChart({ data: docs, assetData, idleFuelRate, standardFuelRate, selectedGroup, loading, ...props }) {

    const [data, setData] = useState([]);
    const [header, setHeader] = useState('--');
    const [averages, setAverages] = useState({
        refuel: 0,
        drain: 0
    });

    useEffect(() => {
        // console.log('Grp - ', selectedGroup);
        // console.log('load .. ', loading);
        if (docs && docs.length) {
            // console.log(`docs:: `, docs)
            // if (selectedGroup !== 'd') {
            //     const grpData = groupDataByInterval(docs, selectedGroup);
            //     console.log(grpData);
            //     setData(grpData)
            // }
            setData(docs);

            // Calculate averages
            const totalDays = docs.length;
            const totalRefuel = docs.reduce((sum, item) => sum + Number(item.total_refuel), 0);
            const totalDrain = docs.reduce((sum, item) => sum + Number(item.total_theft), 0);

            setAverages({
                refuel: totalRefuel / totalDays,
                drain: totalDrain / totalDays
            });
        }
        // setData(docs)
    }, [docs, selectedGroup]);

    // useEffect(() => {
    //     console.log(standardFuelRate);
    // }, [standardFuelRate]);

    const chart = useRef(null);

    useLayoutEffect(() => {
        if (selectedGroup && assetData) {
            const title = selectedGroup === 'w' ? 'Weekly' : selectedGroup === 'm' ? 'Monthwise' : selectedGroup === 'y' ? 'Yearwise' : 'Daywise';
            setHeader(`${title} Possible Refuel & Drain for ${assetData.assetCode}`)
        }

    }, [selectedGroup, assetData]);


    useLayoutEffect(() => {
        if (!loading && data && data.length) {

            let totalRefuelQty = 0;
            let totalTheftQty = 0;
            data.forEach(d => {
                totalRefuelQty += Number(d.total_refuel)
                totalTheftQty += Number(d.total_theft)
            })

            let x = am4core.create("refuelDrainChart", am4charts.XYChart);
            x.hiddenState.properties.opacity = 0;

            let title = x.titles.create();
            title.text = header || '';
            title.fontSize = 15;
            title.marginBottom = 18;

            // Export
            x.exporting.menu = new am4core.ExportMenu();
            x.exporting.filePrefix = "fuel_refuel_drain_data" + new Date().getTime();

            x.paddingRight = 20;

            // Create axes
            let categoryAxis = x.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "date";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;
            categoryAxis.renderer.labels.template.rotation = 90;
            categoryAxis.renderer.labels.template.horizontalCenter = 'middle';
            categoryAxis.renderer.labels.template.verticalCenter = 'middle';
            // Add gap between each record
            categoryAxis.renderer.cellStartLocation = 0.2;
            categoryAxis.renderer.cellEndLocation = 0.8;

            let valueAxis = x.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = "Quantity (Liters)";

            // Create series for refuel
            let refuelSeries = x.series.push(new am4charts.ColumnSeries());
            refuelSeries.name = "Possible Refuel";
            refuelSeries.dataFields.valueY = "total_refuel";
            refuelSeries.dataFields.categoryX = "date";
            refuelSeries.columns.template.tooltipText = "[#333 font-size: 11px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} L[/]";
            refuelSeries.columns.template.fill = am4core.color("#7ed321");
            refuelSeries.columns.template.strokeWidth = 0;
            refuelSeries.columns.template.width = am4core.percent(60);
            refuelSeries.stacked = false;

            // Create series for theft
            let theftSeries = x.series.push(new am4charts.ColumnSeries());
            theftSeries.name = "Possible Drain";
            theftSeries.dataFields.valueY = "total_theft";
            theftSeries.dataFields.categoryX = "date";
            theftSeries.columns.template.tooltipText = "[#333 font-size: 11px]{name} in {categoryX}:\n[/][#333 font-size: 15px]{valueY} L[/]";
            theftSeries.columns.template.fill = am4core.color("#ff6b6b");
            theftSeries.columns.template.strokeWidth = 0;
            theftSeries.columns.template.width = am4core.percent(60);
            theftSeries.stacked = false;

            // Add legend
            x.legend = new am4charts.Legend();
            x.legend.position = "top";
            x.legend.paddingBottom = 20;

            x.data = data;
            chart.current = x;

            return () => {
                if (x) x.dispose();
            };

        }
    }, [data, header]);

    useLayoutEffect(() => {
        if (chart && chart.current)
            chart.current.paddingRight = props.paddingRight;
    }, [props.paddingRight]);

    return (
        <div style={{ padding: '20px' }}>
            {loading ? (
                <div style={{ width: '100%', height: '500px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                    Loading ...
                </div>
            ) : (
                <>
                    <div id="refuelDrainChart" style={{ width: '100%', height: '500px' }} />
                    {data.length > 0 && (
                        <Row gutter={16} style={{ marginTop: '20px' }}>
                            <Col span={12}>
                                <Statistic
                                    title="Average Refuel"
                                    value={averages.refuel}
                                    precision={2}
                                    suffix="L"
                                    valueStyle={{ color: '#7ed321' }}
                                />
                            </Col>
                            <Col span={12}>
                                <Statistic
                                    title="Average Drain"
                                    value={averages.drain}
                                    precision={2}
                                    suffix="L"
                                    valueStyle={{ color: '#ff6b6b' }}
                                />
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </div>
    );
}

export default DeviceRefuelDrainBarChart;